<template>
  <li class="coupon" :data-id="voucher.id" :data-value="voucher.value"> <i class="rightCheck"></i>
    <div class="content">
      <div class="fr">
        <p class="money">￥<span>{{voucher.value}}</span></p>
        <p>满{{voucher.minValue}}元可用</p>
      </div>
      <p class="title font-m font-16">{{voucher.name}}</p>
      <p class="mb10">有效期至<span>{{voucher.inValidTime}}</span></p>
      <p class="font-m">适用课程</p>
      <p class="font-grey mb10">{{voucher.scopeDesc}}</p>
      <p class="detail font-lightgrey">{{voucher.description}}</p>
    </div>
  </li>
</template>

<script>
  export default {
    name: "voucher-li",
    props: ['voucher']
  }
</script>
<style scoped>
.coupon {
    background: #fff;
    padding: 10px;
    border: 1px solid #e5e5e5;
    position: relative;
    margin-bottom: 15px;
    color: #333;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    list-style: none;
  }
  .coupon .font-m {
    font-family: PingFangSC-Medium;
  }
  .coupon .font-16 {
    font-size: 16px;
  }
  .coupon .font-grey {
    color: #666;
  }
  .coupon .font-lightgrey {
    color: #999;
  }
  .coupon p {
    margin-top: 5px;
  }
  .coupon .rightCheck {
    display: none;
  }
  .coupon .mb10 {
    margin-bottom: 10px;
  }
  .coupon.checked .rightCheck {
    display: block;
  }
  .coupon .content {
    border: 2px dashed #e5e5e5;
    padding: 15px;
  }
  .coupon .content .money {
    color: #e37d28;
    font-size: 36px;
    line-height: 50px;
    font-family: PingFangSC-Semibold, Microsoft YaHei;
    font-weight: 600;
  }
  .coupon .content .money+p {
    text-align: right;
  }
  .coupon.disabled:after {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .1) !important;
  }
  .fr {
    float: right;
  } 
  .fr .money{
    margin-bottom: 5px;
  } 
  p.title{
     margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/VoucherLi.vue